import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	users: [],
	userChanges: [],
};

// active account slice
export const usersMapSlice = createSlice({
	name: 'usersMap',
	initialState,
	reducers: {
		setUsers: (state, action) => {
			state.users = action.payload;
		},
		setEmptyUser: (state) => {
			state.user = [];
		},
		addUser: (state, action) => {
			state.users = [
				...state.users,
				{
					name: action.payload.name,
					id: action.payload.id,
					canAdd: action.payload.canAdd,
					canDelete: action.payload.canDelete,
					canExport: action.payload.canExport,
					canUpdate: action.payload.canUpdate,
					canView: action.payload.canView,
				},
			];
		},
		difference: (state, action) => {
			state.userChanges = action.payload;
		},
		deleteUser: (state, action) => {
			state.users = state.users.filter((data) => data.id !== action.payload.id);
		},
		updateCanView: (state, action) => {
			state.users.map((data) => {
				if (data.id === action.payload.id) {
					data.canView = action.payload.canView;
					if (data.canView === false) {
						data.canUpdate = false;
						data.canAdd = false;
						data.canDelete = false;
						data.canExport = false;
					}
				}
				return null;
			});
		},
		updateCanUpdate: (state, action) => {
			state.users.map((data) => {
				if (data.id === action.payload.id) {
					data.canUpdate = action.payload.canUpdate;
				}
				return null;
			});
		},
		updateCanAdd: (state, action) => {
			state.users.map((data) => {
				if (data.id === action.payload.id) {
					data.canAdd = action.payload.canAdd;
				}
				return null;
			});
		},
		updateCanDelete: (state, action) => {
			state.users.map((data) => {
				if (data.id === action.payload.id) {
					data.canDelete = action.payload.canDelete;
				}
				return null;
			});
		},
		updateCanExport: (state, action) => {
			state.users.map((data) => {
				if (data.id === action.payload.id) {
					data.canExport = action.payload.canExport;
				}
				return null;
			});
		},
	},
});

export const {
	setUsers,
	setEmptyUser,
	addUser,
	difference,
	deleteUser,
	updateCanView,
	updateCanUpdate,
	updateCanAdd,
	updateCanDelete,
	updateCanExport,
} = usersMapSlice.actions;

export default usersMapSlice.reducer;
